import { render, staticRenderFns } from "./InspFilteringMultipleInput.vue?vue&type=template&id=23960be7&"
import script from "./InspFilteringMultipleInput.vue?vue&type=script&lang=js&"
export * from "./InspFilteringMultipleInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports